import React from 'react';
import styles from './PublishSection.module.scss';
import CTAButton from '../components/CTAButton';

const PublishSection = ({ onGetAccess }) => {
  return (
    <section className={styles.publish}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.headline}>
            Publish directly to your channels
          </h2>
          <p className={styles.description}>
            Still cross-posting manually? Ditch the copy-paste hustle and automate your publishing across CMS, socials, RSS, and other channels.
          </p>
          <CTAButton onClick={onGetAccess}>
            Get lifetime access for $399 only
          </CTAButton>
        </div>

        <div className={styles.illustration}>
          <img
            src="/Images/Integrations.png"
            alt="Publish to LinkedIn, WordPress, Medium, Instagram and more"
            className={styles.integrationImage}
          />
        </div>
      </div>
    </section>
  );
};

export default PublishSection;
